import React from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import "./epg.scss";

const EPGSportCard = ({ sport, onFocus, onEnterPress, index, rowId }) => {
    const { id, alias, logo } = sport;
    const focusKey = `sport-${rowId}-${index}`;
    const whiteLogo = logo.replace('.svg', '_White.svg');
    
    const { ref, focused } = useFocusable({
        focusKey,
        onEnterPress,
        onFocus: (focusProps) => {
            onFocus({
                ...focusProps,
                index,
            });
        },
        extraProps: {
            focusKey: id,
        },
    });

    return (
        <div ref={ref} className={`sportItem ${focused ? "focusSportShortcut" : ""} `} onClick={() => onEnterPress({ focusKey: id })}>
            <button aria-label={`Filter by ${alias}`} className="sportItem">
                <img src={whiteLogo} alt={alias} className="sportIcon" loading="lazy" decoding="async" />
            </button>
        </div>
    );
};
export default EPGSportCard;
